module.exports = __webpack_public_path__ + "img/open-new-tab.069a9055.svg";